import React from 'react';
import { Provider } from 'react-redux';
import store from '../../../state';

import IncidentReportForm from './IncidentReportForm';

const FormContainer = props => (
  <Provider store={store}>
    <IncidentReportForm {...props} />
  </Provider>
);

export default FormContainer;
